module.exports = __webpack_public_path__ + "static/media/c5.48b85290.jpg";